import { render, staticRenderFns } from "./err404.vue?vue&type=template&id=d6876a36&scoped=true&"
import script from "./err404.vue?vue&type=script&lang=js&"
export * from "./err404.vue?vue&type=script&lang=js&"
import style0 from "./err404.vue?vue&type=style&index=0&id=d6876a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6876a36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCol,VRow})
